import { ExpandableSection, ExpandableSectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { useProduct } from '../../product/productContext'
import { ExcessSummary } from './ExcessSummary'

export interface ExcessExpandableProps extends ExpandableSectionProps {
  quote: Quote
}

export const ExcessExpandable: FunctionComponent<ExcessExpandableProps> = ({
  quote,
  header,
  ...props
}) => {
  const { product } = useProduct()

  return product.excess ? (
    <ExpandableSection header={header} {...props}>
      <ExcessSummary quote={quote} />
    </ExpandableSection>
  ) : null
}
